import { LineItemState } from './lineItemState';
import { OrderStatus } from './orderStatus';
import type { OrderStatusType } from '../types/OrderStatusType';
import type { LineItemStateType } from '../types/LineItemStateType';

export const itemStatusMap: Record<LineItemStateType, OrderStatusType> = {
  [LineItemState.ITEM_INITIAL]: OrderStatus.IN_PROGRESS,
  [LineItemState.ITEM_SENT_TO_MCP]: OrderStatus.IN_PROGRESS,
  [LineItemState.ITEM_CANCEL_REQUESTED]: OrderStatus.CANCEL_REQUESTED,
  [LineItemState.ITEM_CANCEL_REQUEST_PENDING]: OrderStatus.CANCEL_REQUESTED,
  [LineItemState.ITEM_CANCEL_SUCCESS]: OrderStatus.CANCELLED,
  [LineItemState.ITEM_CANCEL_FAILED]: OrderStatus.CANCEL_REQUESTED,
  [LineItemState.ITEM_SHIPPED]: OrderStatus.SHIPPED,

  // Do not tell customers items are in rejected or failed state.
  [LineItemState.ITEM_REJECTED]: OrderStatus.IN_PROGRESS,
  [LineItemState.ITEM_FAILED]: OrderStatus.IN_PROGRESS,
};
